import {
  AccountClient,
  GET_ALL_CUSTOM_FIELDS,
  TicketClient
} from '@nile/graphql';
import { GET_ALL_FIELDS_V2 } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { GET_ROLES } from '@nile/banyan/src/Graphql/Mutations/role';
import { ALL_SHARD_MODULES } from '@nile/components';

const USER_ROLE_ID = '2';

export const getClient = (field) => {
  switch (field) {
    case 'customFields':
      return AccountClient;
    default:
      return AccountClient;
  }
};

export const getVariables = (field) => {
  switch (field) {
    case 'customFields':
      return {
        input: ALL_SHARD_MODULES.requester
      };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'roleId':
      return GET_ROLES;
    case 'customFields':
      return GET_ALL_FIELDS_V2;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'roleId':
    case 'customFields':
      return client.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  switch (field) {
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'roleId':
      return 'getRoles';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'roleId':
      return options?.data?.[key]
        ?.filter((el) => el.roleType?.roleTypeId === USER_ROLE_ID)
        ?.map((el) => ({
          value: el.roleId,
          label: el.name
        }));
    default:
      return options;
  }
};

export const getRequesterValidationFields = () => {
  return {
    customFields: AccountClient.query({
      query: GET_ALL_FIELDS_V2,
      variables: { input: ALL_SHARD_MODULES.requester }
    })
  };
};

export const modelRequesterValidationFields = (type, { data }) => {
  switch (type) {
    case 'customFields':
      return (
        data?.getAllFields?.filter(
          (field) => field?.fieldCategory === 'CUSTOM'
        ) || []
      );
    default:
      return null;
  }
};

export const getRequesterImportFields = [
  {
    label: 'dromo.title.firstName',
    key: 'firstName',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.lastName',
    key: 'lastName'
  },
  {
    label: 'dromo.title.email',
    key: 'email',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      },
      {
        validate: 'regex_match',
        // prettier-ignore
        regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
        errorMessage: 'dromo.validation.emailAddress'
      }
    ]
  },
  {
    label: 'dromo.title.phoneNumber',
    key: 'phoneNumber'
  },
  {
    label: 'dromo.title.roleName',
    key: 'roleId',
    type: 'select',
    selectOptions: getSelectOptions('roleId')
  },
  {
    label: 'dromo.title.clientName',
    key: 'clientName',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.site',
    key: 'siteName',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.reportingManager',
    key: 'reportingManager'
  }
];
